import { Box } from "@mui/material";
import PagesBreakDownGraph from "src/components/pages/dashboard/pagesBreakDownGraph";
import PagesBreakDownList from "src/components/pages/dashboard/PagesBreakDownList";
import useStyles from "./Styles";

const FourthLayer = () => {
  const { classes } = useStyles();
  return (
    <Box id="tour-dashboard-pages-breakdown" className={classes.rootContainer}>
      <Box className={classes.flexItem1}>
        <PagesBreakDownGraph />
      </Box>
      <Box className={classes.flexItem2}>
        <PagesBreakDownList />
      </Box>
    </Box>
  );
};

export default FourthLayer;
